import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bgImage from '../images/background.png';

function EdIcon({ name, size = 20 }) {
    const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };
    switch (name) {
        case 'back':   return <svg {...p}><path d="M19 12H5M12 19l-7-7 7-7"/></svg>;
        case 'shield': return <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
        case 'check':  return <svg {...p}><path d="M20 6 9 17l-5-5"/></svg>;
        default: return null;
    }
}

export default function Editar() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [profileInfo, setProfileInfo] = useState({ id: 0 });
    const [formData, setFormData]       = useState({ name: '', text: '' });
    const [errors, setErrors]           = useState({});
    const [loading, setLoading]         = useState(false);
    const [ready, setReady]             = useState(false);
    const [gangName, setGangName]       = useState('');

    useEffect(() => {
        const stored = localStorage.getItem('userLogged');
        if (stored) setProfileInfo(JSON.parse(stored));
    }, []);

    useEffect(() => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', `${process.env.REACT_APP_API_URL}/winegang/${id}`, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const data = JSON.parse(this.responseText);
                if (profileInfo.id && Number(profileInfo.id) !== Number(data.admin_user_id)) {
                    navigate('/');
                    return;
                }
                setGangName(data.winegang?.winegang_name || '');
                setFormData({ name: data.winegang?.winegang_name || '', text: data.winegang?.text || '' });
                requestAnimationFrame(() => setReady(true));
            }
        };
        xhr.send();
    }, [id, profileInfo.id]);

    const handleChange = (e) => {
        const { id: fid, value } = e.target;
        setFormData(prev => ({ ...prev, [fid]: value }));
        if (errors[fid]) setErrors(prev => ({ ...prev, [fid]: null }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errs = {};
        if (formData.name.length < 2 || formData.name.length > 15) errs.name = t('errors.name_length');
        if (formData.text.length < 2 || formData.text.length > 249) errs.text = t('errors.description_length');
        if (Object.keys(errs).length) { setErrors(errs); return; }

        setLoading(true);
        const data = new FormData();
        data.append('winegang_name', formData.name);
        data.append('text', formData.text);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${process.env.REACT_APP_API_URL}/updategang/${id}`, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                setLoading(false);
                if (this.status === 200) navigate('/gangs');
            }
        };
        xhr.send(data);
    };

    const nameLen = formData.name.length;
    const textLen = formData.text.length;

    return (
        <div className={`cr-stage${ready ? ' cr-ready' : ''}`}>
            <div className="cr-bg" style={{ backgroundImage: `url(${bgImage})` }} />
            <div className="cr-vignette" />
            <div className="cr-grain" />

            <div className="cr-header">
                <button className="gn-back-btn" onClick={() => navigate(-1)} aria-label={t('common.back')}>
                    <EdIcon name="back" size={18} />
                </button>
                <div className="cr-header-center">
                    <EdIcon name="shield" size={15} />
                    <span className="cr-header-title">{gangName || t('common.edit')}</span>
                </div>
                <div style={{ width: 40 }} />
            </div>

            <div className="cr-body">
                <form className="cr-form" onSubmit={handleSubmit} noValidate>

                    <div className={`cr-field cr-field-name${errors.name ? ' cr-field-error' : ''}`}>
                        <div className="cr-field-icon"><EdIcon name="shield" size={16} /></div>
                        <div className="cr-field-inner">
                            <label className="cr-label" htmlFor="name">{t('common.name')}</label>
                            <input id="name" type="text" className="cr-input" value={formData.name}
                                onChange={handleChange} placeholder={t('gangs.placeholder_name')}
                                maxLength={15} autoComplete="off" />
                        </div>
                        <span className={`cr-counter${nameLen > 12 ? ' cr-counter-warn' : ''}`}>{nameLen}/15</span>
                    </div>
                    {errors.name && <p className="cr-error">{errors.name}</p>}

                    <div className={`cr-field cr-field-desc${errors.text ? ' cr-field-error' : ''}`}>
                        <div className="cr-field-inner cr-field-inner-full">
                            <label className="cr-label" htmlFor="text">{t('gangs.label_description')}</label>
                            <textarea id="text" className="cr-textarea" value={formData.text}
                                onChange={handleChange} placeholder={t('gangs.placeholder_description')}
                                maxLength={249} rows={4} />
                        </div>
                        <span className={`cr-counter cr-counter-desc${textLen > 220 ? ' cr-counter-warn' : ''}`}>{textLen}/249</span>
                    </div>
                    {errors.text && <p className="cr-error">{errors.text}</p>}

                    <button type="submit" className={`cr-submit${loading ? ' cr-loading' : ''}`} disabled={loading}>
                        {loading ? <span className="cr-spinner" /> : <><EdIcon name="check" size={17} /><span>{t('common.edit')}</span></>}
                    </button>

                </form>
            </div>
        </div>
    );
}
